module.exports = __webpack_public_path__ + "assets/img/Type E (58).081d0532.jpg";